import styled from "styled-components";

export const Card = styled.div`
    position: relative;
    background: white;
    border: 1px solid #d6d6d6;
    border-radius: 16px;
    padding: 20px;
    width: 100%;
    max-width: 420px;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const HeaderSection = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 16px;
    width: 100%;
`;

export const NetworkSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ImageWrapper = styled.div`
    width: 80px;
    min-width: 80px;
    height: 80px;
    background: #e5e5e7;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;

export const PrinterImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
`;

export const NoImage = styled.div`
    font-size: 12px;
    color: #6b6b6b;
`;

export const Details = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
    min-width: 0;
    flex: 1;
`;

export const Title = styled.div`
    font-size: 16px;
    font-weight: 600;
    color: #1d1d1f;
`;

export const Info = styled.div`
    font-size: 14px;
    color: #5c5c5c;
    line-height: 20px;
`;

export const Tooltip = styled.div`
    position: absolute;

    left: 0;
    bottom: 100%;
    width: max-content;
    max-width: 280px;
    padding: 10px;
    background: #333;
    border-radius: 4px;
    color: #fff;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease;
    pointer-events: none;
    z-index: 1000;

    &::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 12px;
        border-width: 6px;
        border-style: solid;
        border-color: #333 transparent transparent transparent;
    }
`;

export const TooltipWrapper = styled.div`
    position: relative;
    cursor: default;

    &:hover ${Tooltip} {
        opacity: 1;
        visibility: visible;
    }
`;

export const IpBox = styled.input`
    width: 100%;
    height: 40px;
    padding: 0 12px;
    border: 1px solid #d6d6d6;
    border-radius: 10px;
    background: #fafafa;
    color: #1d1d1f;
    font-size: 14px;
    outline: none;
    &:disabled {
        cursor: not-allowed;
        opacity: 1;
        background: #ffffff;
        color: #6b6b6b;
    }
    &::placeholder {
        color: #9ca3af;
    }
`;

// Data sources section
export const MetaSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
